import { render } from "./FaqPageSectionTwo.vue?vue&type=template&id=ffe96036&scoped=true"
import script from "../js/faq-page-section-two.js?vue&type=script&lang=js"
export * from "../js/faq-page-section-two.js?vue&type=script&lang=js"

import "./FaqPageSectionTwo.vue?vue&type=style&index=0&id=ffe96036&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe96036"]])

export default __exports__